import React from 'react';
import properties from '../../../modules/ajio-util/properties';

const imageBaseUrl = properties.getProperty('imageBaseUrl');

const ListUsers = ({ eventData, isShowWinners, day }) => {
  const topWinner = isShowWinners ? eventData[0] : null;
  const winnersList = isShowWinners && eventData.length > 0 ? eventData.slice(1) : eventData;

  return (
    <div className="list_section">
      <ul className="listing">
        {topWinner && isShowWinners ? (
          <div className="list_winner">
            <div className="winners_list_left">
              <img src={`${imageBaseUrl}/static/img/leaderboard/winner.svg`} alt="Trophy icon" />
            </div>
            <div className="winners_list_right">
              <span>{day}</span>
              <br />
              <br />
              <span>
                Winner* of <span className="winners_prize">iPhone 8</span>
              </span>
              <br />
              <span className="winners_name">{topWinner.userName}</span>
              <br />
              <span className="winners_mobile_no">{topWinner.mobileNo}</span>
              <br />
            </div>
            <div className="tnc_section">
              <span>*Subject to change basis returns and cancellation | </span>
              <a href="https://www.ajio.com/ajio-own-sale-policy"> View terms and conditions</a>
            </div>
          </div>
        ) : null}
        {topWinner && isShowWinners ? (
          <p className="regular_winner_header">{day} - Winners* of Rs. 1,500 voucher</p>
        ) : null}
        {winnersList && winnersList.length > 0 ? (
          winnersList.map((item, index) => (
            <li
              className={`${
                index === 0 && !topWinner ? 'users_row list_first_elem' : 'users_row'
              } ${topWinner && 'alter-padng'}`}
              key={index}
            >
              <span className="serNum">{index + 1}</span>
              {item.userName && (
                <span>
                  <span className="mobNum">{item.userName}</span>
                  <br />
                </span>
              )}
              <span className={`${topWinner ? 'winners_mobile_no' : 'mobNum'}`}>
                {item.mobileNo}
              </span>
              {!topWinner && (
                <span>
                  <span className="amountText float-right">Rs. {item.total}</span>
                </span>
              )}
              {index === 0 && !topWinner && <span className="iphoneText">iPhone 8 contender</span>}
            </li>
          ))
        ) : (
          <div className="prev_day_header">
            <img
              src={`${imageBaseUrl}/static/img/leaderboard/hourglass 1.svg`}
              alt="Hourglass icon"
            />
            <div className="prev_day_right_text">
              <p className="closed-day">Day Closed</p>
              <span>{day} Winners*</span>
              <br />
              <span>Will be announced by 20 Jan, 3 pm </span>
            </div>
          </div>
        )}
      </ul>
    </div>
  );
};

export default ListUsers;
